import {Component, OnInit, Input} from '@angular/core';
import { DatasourceDatasSelectionModel } from '../datasource-datas-selection.model';

@Component({
    selector: 'abw-datasource-datas-selection-result',
    templateUrl: './datasource-datas-selection-result.component.html',
    styleUrls: ['./datasource-datas-selection-result.component.scss']
})
export class DatasourceDatasSelectionResultComponent implements OnInit {
	@Input() model: DatasourceDatasSelectionModel;
    @Input() value: any;

    constructor() {
    }

    ngOnInit() {
    }
}